import React from 'react';

import { func, oneOf } from 'prop-types';

import './menu-icon.scss';

import { MenuIconType } from '@philips-emr/tws-components-api';
import { classNames, enumValues, isFunction } from '@philips-emr/tws-utils';

import { ReactComponent as BackIcon } from '../../../resources/assets/components/menu-back.svg';
import { ReactComponent as CloseIcon } from '../../../resources/assets/components/menu-close.svg';
import { ReactComponent as BurgerIcon } from '../../../resources/assets/components/menu-hamburger.svg';

function getIcon(type = MenuIconType.BURGER) {
  return {
    [MenuIconType.BACK]: <BackIcon />,
    [MenuIconType.BURGER]: <BurgerIcon />,
    [MenuIconType.CLOSE]: <CloseIcon />,
  }[type];
}

function MenuIcon(props) {
  const { onClick, type } = props;

  const className = classNames({
    'c-menu-icon': true,
    'c-menu-icon--close': type === MenuIconType.CLOSE,
    'c-menu-icon--back': type === MenuIconType.BACK,
  });

  const onMenuClick = (event) => {
    event.preventDefault();

    isFunction(onClick) && onClick();
  };

  return (
    <div className={className} onClick={onMenuClick}>
      <div className="c-menu-icon__icon">
        {getIcon(type)}
      </div>
    </div>
  );
}

MenuIcon.propTypes = {
  onClick: func,
  type: oneOf(enumValues(MenuIconType)),
};

MenuIcon.defaultProps = {
  type: MenuIconType.BURGER,
};

export default MenuIcon;
